import { Button, Popconfirm, Space } from "antd"
import { useNavigate } from "react-router-dom";
import TableComponent from "../../components/TableComponent";
import { deleteCode, getCodes } from "../../store/slices/codeSlice";
import { DeleteFilled, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { useState } from "react";
import Can from "../../permission/Can";

const CodeList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const [reload, setReload] = useState(false)
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);

    const showPopconfirm = (codeId) => {
        setOpen(codeId);
    };

    const handleDeleteCode = async (id) => {
        try {
            setConfirmLoading(true);

            const resultAction = await dispatch(deleteCode(id))
            if (deleteCode.fulfilled.match(resultAction)) {
                setAlertMessage(resultAction?.payload?.message || "Deleted")
                setAlertType('success')
                setReload(!reload)
                setOpen(false);
                setConfirmLoading(false);
                setTimeout(() => {
                    setAlertMessage('');
                }, 4000);
            }
        } catch (error) {
            setConfirmLoading(false);
            setAlertMessage("Error deleting truck")
            setAlertType('error')
            setOpen(null);
        }
        
    };

    const handleCancel = () => {
        console.log('Clicked cancel button');
        setOpen(false);
    };
    const columns = [
        {
            title: 'Code',
            dataIndex: 'code',
            key: 'code',
        },
        {
            title: 'Start Date',
            dataIndex: 'start_date',
            key: 'start_date',
            render : (_, data) => {
                const date = new Date(data?.start_date);
                return date.toDateString()
            }
        },
        {
            title: 'End Date',
            dataIndex: 'end_date',
            key: 'end_date',
            render : (_, data) => {
                const date = new Date(data?.end_date);
                return date.toDateString()
            }
        },
        {
            title: 'No Of Users',
            dataIndex: 'no_of_users',
            key: 'no_of_users',
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, data) => (
                <Space>
                    <Can permission="edit_code">
                        <Button onClick={() => navigate('/code/edit/' + data?._id)} icon={<EditOutlined />} size="small">Edit</Button>
                    </Can>
                    <Can permission="delete_code">
                        <Popconfirm
                            title="Delete confirmation"
                            description="Do you want to delete this?"
                            open={open == data?._id}
                            icon={<DeleteFilled />}
                            onConfirm={() => handleDeleteCode(data?._id)}
                            okButtonProps={{ loading: confirmLoading }}
                            onCancel={handleCancel}
                        >
                            <Button icon={<DeleteOutlined />} onClick={() => showPopconfirm(data?._id)} size="small" danger>Delete</Button>
                        </Popconfirm>
                    </Can>
                </Space>
            ),
        },
    ];
    return (
        <div>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1>Codes</h1>
                <Can permission="create_code">
                    <Button type="primary" onClick={() => navigate('/code/add')}>Add Code</Button>
                </Can>
            </div>
            <TableComponent
                listData={getCodes}
                columns={columns}
                reload={reload}
                placeholder="Search codes..."
            />
        </div>
    )
}

export default CodeList